import React from 'react';
import AnnouncementBar from '../components/AnnouncementBar';
import Footer from '../components/Footer';
import SponsorsSection from '../components/SponsorsSection';
import ScrollToTop from '../components/ScrollToTop';
import TornPaperWrapper from '../components/TornPaperWrapper';
import './PrivacyPolicy.css';

const DeleteAccount = () => {
  return (
    <div className="page-wrapper">
      <AnnouncementBar />

      <section className="hero-section">
        <div className="hero-background-wrapper">
          <video src={"/hero-final.mp4"} alt="oc mena festival" className="hero-background-video" autoPlay muted loop playsInline />
          <div className="hero-gradient-overlay"></div>
        </div>

        <TornPaperWrapper>
          <h1 className="card-title">Request Account Deletion</h1>
          <div className="legal-content">
            <p className="effective-date">Effective Date: August 9, 2026</p>

            <p>MENA Events, Inc ("MENA Events," "we," "us," or "our") respects your right to request deletion of your account and associated personal data. This page explains how you can request that your OC MENA Festival account and related data be deleted.</p>

            <h2>How to Request Account Deletion</h2>
            <p>To request that your account and associated data be deleted, please follow these steps:</p>
            <ul>
              <li><strong>Step 1:</strong> Send an email to <a href="mailto:info@ocmenafestival.com?subject=Account%20Deletion%20Request">info@ocmenafestival.com</a> with the subject line "Account Deletion Request."</li>
              <li><strong>Step 2:</strong> Include your full name, the email address associated with your OC MENA Festival account, and your phone number (if applicable) so we can verify your identity.</li>
              <li><strong>Step 3:</strong> Clearly state in the email body that you want your account and all associated personal data deleted.</li>
              <li><strong>Step 4:</strong> Our team will process your request within 30 days of receipt and send a confirmation email once deletion is complete.</li>
            </ul>

            <h2>What Data Is Deleted</h2>
            <p>Upon processing your account deletion request, the following types of data associated with your account will be permanently deleted:</p>
            <ul>
              <li><strong>Account Information</strong> — Your name, email address, phone number, and password credentials.</li>
              <li><strong>Profile Data</strong> — Any profile preferences, saved settings, and user-generated content.</li>
              <li><strong>Marketing & Communication Data</strong> — Your subscription status for newsletters, SMS notifications, and marketing communications.</li>
              <li><strong>App Usage Data</strong> — Device identifiers and usage analytics tied to your account.</li>
            </ul>

            <h2>What Data May Be Retained</h2>
            <p>Certain data may be retained for legal, accounting, or security purposes, including:</p>
            <ul>
              <li><strong>Transaction & Order Records</strong> — Records of ticket purchases, refunds, and payment transactions may be retained as required by financial and tax regulations (typically up to 7 years).</li>
              <li><strong>Legal Records</strong> — Data required to be kept for compliance with legal obligations, dispute resolution, or enforcement of our terms.</li>
              <li><strong>Anonymized Data</strong> — Data that has been irreversibly de-identified and can no longer be linked to you may be retained for analytics and service improvement.</li>
            </ul>
            <p>Retained data will be held only for as long as legally required and will not be used for any other purpose.</p>

            <h2>Additional Retention Period</h2>
            <p>Any data retained for legal compliance will be securely stored and automatically deleted once the applicable retention period expires, unless otherwise required by law.</p>

            <h2>Impact of Account Deletion</h2>
            <p>Please be aware that deleting your account will:</p>
            <ul>
              <li>Permanently remove your ability to log in to the OC MENA Festival app and website.</li>
              <li>Remove access to any active tickets, transfer history, and wallet passes associated with your account.</li>
              <li>Cancel any pending transfers or requests associated with your account.</li>
            </ul>
            <p>This action is irreversible. If you wish to use our services again in the future, you will need to create a new account.</p>

            <h2>Contact Us</h2>
            <p>If you have any questions about the account deletion process, please contact:</p>
            <p><strong>MENA Events, Inc</strong><br />
            Email: <a href="mailto:info@ocmenafestival.com">info@ocmenafestival.com</a><br />
            Website: ocmenafestival.com</p>
          </div>
        </TornPaperWrapper>

        <div className="lanterns-container">
          <img loading="lazy" src={"/lanterns.webp"} alt="festival lanterns" className="lanterns-image" />
        </div>
      </section>

      <SponsorsSection />
      <Footer />
      <ScrollToTop />
    </div>
  );
};

export default DeleteAccount;
